import { MotifCard, MotifCardBody, MotifChip, MotifChipGroup, MotifFileUploader, MotifFileUploaderItem, MotifFormField } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationMessageReply = (props: any) => {
    const { content } = props;
    const dispatch = useDispatch();
    const renderFileSelect = useCallback(() => {
        const { options } = content;
        return (
            <MotifFormField>
                <MotifFileUploader
                    id="my-id"
                    label="Drag and drop a document or upload"
                    onDrop={function Xo() { }}
                >
                    <></>
                    {/* <MotifFileUploaderItem
      aria-label="Item aria-label text"
    //   fileIcon={<MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />}
      fileName="file_in_progress.txt"
      fileSize={10000}
      id={1}
      onRemove={function Xo(){}}
      percentUploaded={50}
      removable
      showProgress
    /> */}
                </MotifFileUploader>
            </MotifFormField>
        )
    }, [])
    return (
        <MotifCard className="!w-full">
            <MotifCardBody>
                <p className="text-lg font-bold">
                    {content.title}
                </p>
                <p className="text-md">
                    {content.subtitle}
                </p>
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationMessageReply